import type {
  Padding,
  Palette,
} from '@shieldpay/theme-provider-ui/theme/types';

export const buttonPadding = {
  small: { box: { x: 'baseNeg6' }, text: { x: 'baseNeg6' } },
  medium: { box: { x: 'baseNeg5' }, text: { x: 'baseNeg6' } },
  large: { box: { x: 'baseNeg4' }, text: { x: 'baseNeg5' } },
} as const satisfies Record<string, { box: Padding; text: Padding }>;

export const sizes = Object.keys(buttonPadding) as Array<
  keyof typeof buttonPadding
>;

export const variantConfig = {
  default: 'neutral100',
  primary: 'primary200',
  warning: 'warning200',
  alert: 'alert200',
  success: 'success200',
} satisfies Record<string, Palette>;
